var exports = {
  "wE": "ReportFlowModal.module__directionScope___VXpUSD",
  "VA": "ReportFlowModal.module__subtitle___VXpUSD",
  "Qs": "ReportFlowModal.module__content___VXpUSD",
  "rf": "ReportFlowModal.module__body___VXpUSD",
  "Lq": "ReportFlowModal.module__loading___VXpUSD",
  "Hj": "ReportFlowModal.module__loadError___VXpUSD",
  "eU": "ReportFlowModal.module__accountNotice___VXpUSD",
  "Es": "ReportFlowModal.module__accountNoticeTitle___VXpUSD",
  "jU": "ReportFlowModal.module__accountNoticeText___VXpUSD",
  "Dc": "ReportFlowModal.module__accountNoticeActions___VXpUSD",
  "fB": "ReportFlowModal.module__submitNote___VXpUSD",
  "QL": "ReportFlowModal.module__splitFooter___VXpUSD",
};

module.exports = exports;
